const ITEMS = [
  { 
    icon: '💰',
    title: 'Выгодные цены', 
    desc: 'Прямые поставки со всего мира без посредников. Экономия до 30% по сравнению с розницей. Минимальный заказ от 5 кг.' 
  },
  { 
    icon: '📦',
    title: 'Широкий ассортимент', 
    desc: 'Более 100 сортов: улуны, зелёный и чёрный чай, травяные сборы, ройбуш. Постоянное пополнение каталога.' 
  },
  { 
    icon: '🚚',
    title: 'Быстрая доставка', 
    desc: 'Доставка по всей России. Индивидуальное производство под каждого клиента. Отправка в течение 3–5 рабочих дней после оплаты заказа.' 
  },
  { 
    icon: '📄',
    title: 'Все документы', 
    desc: 'Полный пакет документов для юрлиц и ИП: счета, накладные, сертификаты. Работаем с НДС и без НДС.' 
  },
  { 
    icon: '⭐',
    title: 'Контроль качества', 
    desc: 'Каждая партия проверяется перед отправкой. Гарантия свежести и соответствия описанию. Возврат при несоответствии.' 
  },
  { 
    icon: '💬',
    title: 'Персональная поддержка', 
    desc: 'Менеджер отвечает в Telegram в течение рабочего дня. Помогаем с выбором, консультируем по ассортименту и условиям.' 
  },
];

export function Benefits() {
  return (
    <section className="py-16 sm:py-24 px-4 bg-tea-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-tea-900">
            Почему выбирают нас
          </h2>
          <p className="mt-3 text-lg text-tea-600 max-w-xl mx-auto">
            Прямые поставки, выгодные цены и персональный подход к каждому клиенту
          </p>
        </div>
        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {ITEMS.map((item) => (
            <div
              key={item.title}
              className="p-6 rounded-xl bg-white border border-tea-100 hover:shadow-md transition-shadow"
            >
              <div className="text-3xl mb-3">{item.icon}</div>
              <h3 className="text-lg font-bold text-tea-900 mb-2">{item.title}</h3>
              <p className="text-sm text-tea-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
